import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {FilterProps} from "../components/table/tableTypes";

export const getAbandonedCheckoutsLog = async (selectedDomain: string, filters: FilterProps[]): Promise<AppFetchResponse> => {
    const { from, to } = filters.find(filter => filter.filterKey === 'days')!;
    const statusFilter = filters.find(filter => filter.filterKey === 'status')!;
    const statuses = statusFilter.options?.filter(option => statusFilter.selected ? option?.key === statusFilter.selected : option?.key).map(option => option?.key);
    const clientFilter = filters.find(filter => filter.filterKey === 'clientId')!;
    const clientParam = clientFilter?.value ? `&clientId=${clientFilter.value}` : '';
    const phoneFilter = filters.find(filter => filter.filterKey === 'phone')!;
    const phoneParam = phoneFilter?.value ? `&phone=${phoneFilter.value}` : '';
    const checkoutFilter = filters.find(filter => filter.filterKey === 'checkoutId')!;
    const checkoutParam = checkoutFilter?.value ? `&checkoutId=${checkoutFilter.value}` : '';

    return appFetch({
        endpoint: `abandoned-checkouts-log?domain=${selectedDomain}&from=${from}&to=${to}&statuses=${statuses}${clientParam}${phoneParam}${checkoutParam}`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        isEncrypted: true,
    });
}